<template>
  <b-container fluid class="d-flex flex-column py-3">
    <b-table
      hover
      no-border-collapse
      selectable
      select-mode="single"
      sticky-header
      thead-tr-class="small"
      tbody-tr-class="h5"
      :items="items"
      :fields="computedFields"
      @row-selected="onRowSelected"
    ></b-table>
  </b-container>
</template>

<script>
import { getExportHistoryListAPI, getExportHistoryAPI } from '@/api';
import { saveAs } from 'file-saver';
import { replaceDateValue } from '@/compare';
import { dtFormat } from '@/constants';
import Encoding from 'encoding-japanese';
import { DateTime } from 'luxon';

export default {
  name: 'ExportHistory',
  data() {
    return {
      fields: [], // 項目
      items: [] // 値
    };
  },
  async mounted() {
    // 画面を初期化
    this.$emit('initView', { viewId: this.$options.name, useToolButtons: false });

    // 出力履歴を検索する
    await this.getExportHistoryList();

    this.$store.commit('setMessage', '出力する履歴を選択します');
  },
  computed: {
    computedFields() {
      return this.fields.filter((field) => {
        if (field.key === 'exportDtKey') {
          return false;
        }
        return true;
      });
    }
  },
  methods: {
    /**
     * 出力履歴行選択時
     * @param {!object} items 選択項目(出力履歴)
     */
    onRowSelected: async function (items) {
      // 出力履歴情報取得API
      const ret = await getExportHistoryAPI(items[0].exportDtKey);
      if (!ret) {
        this.$store.commit('setMessage', '通信エラー(照合履歴CSV取得)');
        return false;
      }
      const bodyUint8Array = new Uint8Array(ret.data);

      // blobへの変換
      const unicodeArray = Encoding.convert(bodyUint8Array, {
        to: 'UNICODE',
        from: 'UTF8',
        type: 'array'
      });
      const sjisArray = Encoding.convert(unicodeArray, {
        to: 'SJIS',
        from: 'UNICODE',
        type: 'array'
      });
      const codes = new Uint8Array(sjisArray);
      const dt = DateTime.local().toFormat(dtFormat.FILE);
      const fileName = `${items[0].readNm}_${dt}.csv`;
      const blob = new Blob([codes], { type: 'application/octet-stream' });
      saveAs(blob, fileName);

      // 照合履歴ダウンロード再表示
      this.getExportHistoryList();
      return true;
    },
    getExportHistoryList: async function () {
      // 一覧表示項目選択
      this.fields.splice(0);
      this.fields.push({ key: 'exportDt', label: '日時', thClass: 'p-1', tdClass: 'px-1' });
      this.fields.push({ key: 'readNm', label: '読取ルール', thClass: 'p-1', tdClass: 'px-1' });
      this.fields.push({ key: 'exportDtKey', label: '履歴キー' });

      // 出力履歴情報リスト取得API
      const ret = await getExportHistoryListAPI();
      if (!ret) {
        this.items.splice(0);
        this.$store.commit('setMessage', '通信エラー(履歴情報リスト取得)');
      }

      // 出力日時のフォーマットセット
      this.items = ret.data;
      for (const item of this.items) {
        item['exportDt'] = replaceDateValue(item['exportDt'], dtFormat.LIST);
      }
    }
  }
};
</script>
\

<style>
div.container-fluid {
  height: 100%;
}
.b-table-sticky-header {
  max-height: none !important;
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
}
</style>
